import type { STATUS_TAG_VARIANTS } from 'redesign/components/atoms/status-tag/constants'
import { TASK_STATES } from 'redesign/components/templates/ContentLists/TaskList/constants'
import type { Maybe } from 'shared/graphql/graphql'

export const normalizeStatus = (status: Maybe<string> | undefined): keyof typeof STATUS_TAG_VARIANTS | undefined => {
  const variant: Record<string, keyof typeof STATUS_TAG_VARIANTS> = {
    [TASK_STATES.open]: 'open',
    [TASK_STATES.pending]: 'pending',
    [TASK_STATES.closed]: 'closed',
    [TASK_STATES.todo]: 'open',
  } as const

  return variant[status ?? ''] ?? undefined
}
